import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { renderClose } from "../../common/dialog";
import { useState } from "react";
import { CustomerDto, newRefund, RefundEditDto } from "./types";
import { createEntityStore, UseEntityStore } from "../../common/entityStore";
import { propDateField, propNumberField, propTextField } from "../../common/entityStoreForm";
import { propCurrency, propLengthMax, propMinValueExclusive, propRequired, propValidValue } from "../../common/entityStoreValidators";
import { customerDialogTitle, useCustomerBasicInfo } from "./common";

export const RefundDialog = (props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
    orderId: number;
    onRefundCreated(): void;
}) => {
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    const [{ useRefundStore }] = useState(() => {
        const useRefundStore = createEntityStore<RefundEditDto>({
            data: newRefund(props.orderId), path: "customers/refunds", id: null, getNewId: p => p.id!, saveProps: ["orderId", "refAmt", "refDte", "nte"],
            onCreated() {
                props.onRefundCreated();
                props.close();
            },
            propValidators: [
                propValidValue("refAmt", "refAmtFormatted"),
                propRequired("refAmt"),
                propCurrency("refAmt"),
                propMinValueExclusive("refAmt", 0),

                propValidValue("refDte", "refDteFormatted"),
                propRequired("refDte"),

                propRequired("nte"),
                propLengthMax("nte", 500),
            ]
        });
        return { useRefundStore };
    });
    const { save, isSaveDisabled } = useRefundStore(p => ({ save: p.save, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{customerDialogTitle("New refund", customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container>
                <Grid item xs={12}>{propDateField(useRefundStore)("refDte", "refDteFormatted", "Refund date")}</Grid>
                <Grid item xs={12}>{propNumberField(useRefundStore)("refAmt", "refAmtFormatted", "Refund amount", { isCurrency: true })}</Grid>
                <Grid item xs={12}>{propTextField(useRefundStore)("nte", "Note", { multiline: true })}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button disabled={isSaveDisabled} onClick={save} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};
